/**
 * Inject a third-party script once (Osano, Adobe, etc.).
 * @param {string} src
 * @param {{ id?: string, async?: boolean }} options
 * @returns {Promise<void>}
 */
export function loadScript(src, { id, async = true } = {}) {
  if (!src) {
    return Promise.resolve();
  }
  if (document.querySelector(`script[src="${src}"]`)) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = async;
    if (id) {
      script.id = id;
    }
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
}
